import { weatherTimeWithID, WX_ID_SURFACEANALYSIS } from "../../../store/WeatherContentsState";
import { useRecoilValue } from "recoil";

function LegendSurfaceAnalysis() {
  const timeInfo = useRecoilValue(weatherTimeWithID(WX_ID_SURFACEANALYSIS));
  return (
    <div className="legend-contents-time">
      {timeInfo.validTime}&nbsp;{timeInfo.baseTime}
    </div>
  )
}

export default LegendSurfaceAnalysis;